import { CircleAlert } from 'lucide-react';
import Link from 'next/link';
import { Alert, AlertDescription, AlertTitle } from '@repo/ux/alert';
import { Button } from '@/ui/button';

type FlowErrorStateProps = Readonly<{
  title: string;
  description?: string;
  /** Recovery action. Rendered only when both label and href are provided. */
  actionLabel?: string;
  actionHref?: string;
}>;

/**
 * Standard error/empty state for user-facing flows: destructive alert with an
 * icon, plain-language title, optional detail, and one recovery action.
 * Replaces ad-hoc `<div>Error...</div>` and raw red-text blocks.
 */
export function FlowErrorState({
  title,
  description,
  actionLabel,
  actionHref,
}: FlowErrorStateProps) {
  return (
    <Alert variant="destructive" className="text-left">
      <CircleAlert aria-hidden="true" />
      <AlertTitle className="line-clamp-none">{title}</AlertTitle>
      {description && <AlertDescription>{description}</AlertDescription>}
      {actionLabel && actionHref && (
        <div className="col-start-2 mt-3">
          <Button asChild variant="outline">
            <Link href={actionHref}>{actionLabel}</Link>
          </Button>
        </div>
      )}
    </Alert>
  );
}
